import { FormattedMessage } from "react-intl";
import { motion } from "framer-motion";
import { ballMotion } from "../../../animations/framer";

const style = {
	whyWrapper: `relative py-4 lg:basis-1/2`,
	titleWrapper: `mb-12`,
	title: `text-lg tracking-wide text-center text-white lg:text-4xl uppercase aubrey-pro font-bold`,
	list: `relative flex flex-col gap-8 mb-12`,
	item: `flex items-center z-10`,
	numb: `w-[50px] text-white tracking-wider text-5xl mr-12`,
	whyInfo: `lg:text-lg`,
	limeLine: `underline underline-offset-4 decoration-lime decoration-3`,
	redLine: `underline underline-offset-4 decoration-red decoration-3`,
	blueLine: `underline underline-offset-4 decoration-blue decoration-3`,
	neonLime: `absolute top-[10%] left-[30%] shadow-[0px_0px_100px_30px_#DAF66A]`,
	neonLimeTwo: `absolute top-[50%] left-[60%] shadow-[0px_0px_50px_30px_#DAF66A]`,
	neonBlue: `absolute top-[60%] left-[40%] shadow-[0px_0px_50px_30px_#4430D0]`,
	neonBlueTwo: `absolute top-[10%] left-[20%] shadow-[0px_0px_50px_30px_#4430D0]`,
	neonRed: `absolute top-[40%] left-[20%] shadow-[0px_0px_50px_30px_#FB7151]`,
	neonRedTwo: `absolute top-[10%] left-[70%] shadow-[0px_0px_50px_30px_#FB7151]`,
};

const WhyUs = () => {
	return (
		<div className={style.whyWrapper}>
			<div className={style.titleWrapper}>
				<h2 className={style.title}>
					<FormattedMessage id='courseProfits' />
				</h2>
			</div>
			<div className={style.list}>
				<motion.div
					variants={ballMotion}
					animate='startone'
					className={style.neonLime}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='starttwo'
					className={style.neonLimeTwo}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startthree'
					className={style.neonBlue}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startfour'
					className={style.neonBlueTwo}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startfive'
					className={style.neonRed}
				></motion.div>
				<motion.div
					variants={ballMotion}
					animate='startsix'
					className={style.neonRedTwo}
				></motion.div>
				<div className={style.item}>
					<span className={style.numb}>01</span>
					<p className={style.whyInfo}>
						<FormattedMessage id='courseProfitsOne' />
					</p>
				</div>
				<div className={style.item}>
					<span className={style.numb}>02</span>
					<p className={style.whyInfo}>
						<FormattedMessage id='courseProfitsTwo' />
					</p>
				</div>
				<div className={style.item}>
					<span className={style.numb}>03</span>
					<p className={style.whyInfo}>
						<FormattedMessage id='courseProfitsThree' />
					</p>
				</div>
				<div className={style.item}>
					<span className={style.numb}>04</span>
					<p className={style.whyInfo}>
						<FormattedMessage id='courseProfitsFour' />
					</p>
				</div>
			</div>
		</div>
	);
};

export default WhyUs;
